import React from 'react';
import { FaTools } from 'react-icons/fa';
import logo from '../assets/logo.svg';

const MaintenancePage = () => {
    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f0f2f5',
            fontFamily: "'Poppins', sans-serif",
            padding: '20px',
            textAlign: 'center'
        }}>
            <div style={{
                background: 'white',
                padding: '40px',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                maxWidth: '500px',
                width: '100%'
            }}>
                <img src={logo} alt="Logo Sekolah" style={{ height: '60px', marginBottom: '20px' }} />

                <div style={{ fontSize: '3rem', color: '#faad14', marginBottom: '10px' }}>
                    <FaTools />
                </div>

                <h1 style={{ fontSize: '1.8rem', color: '#333', marginBottom: '10px' }}>Website Sedang Maintenance</h1>

                <p style={{ color: '#666', lineHeight: '1.6', marginBottom: '25px' }}>
                    Mohon maaf, saat ini kami sedang melakukan pembaruan sistem untuk meningkatkan kualitas layanan.
                    Silakan kembali lagi dalam beberapa saat.
                </p>


            </div>
        </div>
    );
};

export default MaintenancePage;
